

// import CarouselExamples from "../../components/carousel/CarouselModal";
import HomeComponent from "../../components/main/HomeComponent";
import Main from "../../components/main/Main";
import PopupAuthComponent from "../../components/popUpg/PopupAuthComponent";
import GuidePage from "../k_guidePage/GuidePage";
import FadeIn from "../Theme/FadeIn";
import FadeInOnScroll from "../Theme/FadeInOnScroll";

export default function Home() {
    return (
        <>

            <FadeIn delay={700}>
                <PopupAuthComponent/>
                <Main />
            </FadeIn>
            {/* <CarouselExamples/> */}
            <FadeInOnScroll delay={800}>
                <HomeComponent />
                <GuidePage/>
                
            </FadeInOnScroll>

        </>
    )
}